import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in touch`}</h2>
    <p>{`I'm open for Freelancing. `}<br />{`
If you have a job, you can find me on these platforms: `}<a parentName="p" {...{
        "href": "https://instagram.com/arun99.dev"
      }}>{`Instagram`}</a>{`, `}<a parentName="p" {...{
        "href": "https://t.me/arun99_dev"
      }}>{`Telegram`}</a>{`, `}<a parentName="p" {...{
        "href": "https://github.com/arun99-dev"
      }}>{`Github`}</a>{` & `}<a parentName="p" {...{
        "href": "https://www.twitter.com/arun99_dev"
      }}>{`Twitter`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      